module.exports = __webpack_public_path__ + "static/media/especialistas_testimonios11.e6939c42.jpeg";